import React, { useState } from "react";
import { axiosInstance } from "../axiosInstance";
import {
  Upload,
  ArrowRight,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Linkedin,
} from "lucide-react";
import "./Footer.css";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const submitContactDetails = (formData) => {
    return axiosInstance.post(`/contact-us`, formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    submitContactDetails(formData)
      .then((response) => {
        console.log("Contact details submitted successfully:", response);
        alert("Contact details submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Error submitting contact details:", error);
      });
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
      <section
        style={{
          background:
            "linear-gradient(135deg, #7B6B98 0%, #6B5B88 50%, #5B4B78 100%)",
          padding: "4rem 0 2rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: "20%",
            left: "10%",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            background: "rgba(107, 91, 136, 0.4)",
            filter: "blur(60px)",
            zIndex: 0,
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            left: "5%",
            fontSize: "8rem",
            opacity: 0.3,
            zIndex: 0,
          }}
        >
          🐾
        </div>
        <div
          style={{
            position: "absolute",
            top: "30%",
            right: "10%",
            width: "200px",
            height: "400px",
            opacity: 0.2,
            zIndex: 0,
          }}
        >
          <div
            style={{
              width: "150px",
              height: "300px",
              border: "3px solid rgba(255,255,255,0.2)",
              borderRadius: "10px",
              transform: "rotate(-15deg)",
              position: "absolute",
            }}
          ></div>
          <div
            style={{
              width: "120px",
              height: "250px",
              border: "3px solid rgba(255,255,255,0.2)",
              borderRadius: "10px",
              transform: "rotate(15deg)",
              position: "absolute",
              right: 0,
            }}
          ></div>
        </div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row" style={{ borderRadius: "15px" }}>
            <div className="col-lg-5 col-md-5 col-sm-12 mb-5">
              <h2
                style={{
                  fontSize: "clamp(2.5rem, 5vw, 4rem)",
                  fontWeight: "bold",
                  color: "#fff",
                  marginBottom: "2rem",
                }}
              >
                Contact us
              </h2>
            </div>

            <div className="col-lg-5 col-md-5 col-sm-12 offset-md-2 offset-lg-2">
              <div
                style={{
                  background: "#fff",
                  borderRadius: "15px",
                  padding: "2.5rem",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "2rem",
                  }}
                >
                  Contact Form
                </h3>

                <div>
                  <div className="mb-4">
                    <label
                      style={{
                        display: "block",
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      style={{
                        border: "none",
                        borderBottom: "2px solid #ddd",
                        borderRadius: "0",
                        padding: "0.75rem 0",
                        fontSize: "1rem",
                        transition: "border-color 0.3s",
                      }}
                      onFocus={(e) =>
                        (e.target.style.borderBottomColor = "#7B6B98")
                      }
                      onBlur={(e) =>
                        (e.target.style.borderBottomColor = "#ddd")
                      }
                    />
                  </div>

                  <div className="mb-4">
                    <label
                      style={{
                        display: "block",
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "0.5rem",
                      }}
                    >
                      E-mail
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      style={{
                        border: "none",
                        borderBottom: "2px solid #ddd",
                        borderRadius: "0",
                        padding: "0.75rem 0",
                        fontSize: "1rem",
                        transition: "border-color 0.3s",
                      }}
                      onFocus={(e) =>
                        (e.target.style.borderBottomColor = "#7B6B98")
                      }
                      onBlur={(e) =>
                        (e.target.style.borderBottomColor = "#ddd")
                      }
                    />
                  </div>

                  <div className="mb-4">
                    <label
                      style={{
                        display: "block",
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      style={{
                        border: "none",
                        borderBottom: "2px solid #ddd",
                        borderRadius: "0",
                        padding: "0.75rem 0",
                        fontSize: "1rem",
                        transition: "border-color 0.3s",
                      }}
                      onFocus={(e) =>
                        (e.target.style.borderBottomColor = "#7B6B98")
                      }
                      onBlur={(e) =>
                        (e.target.style.borderBottomColor = "#ddd")
                      }
                    />
                  </div>

                  <div className="mb-4">
                    <label
                      style={{
                        display: "block",
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Message
                    </label>
                    <input
                      type="text"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control"
                      style={{
                        border: "none",
                        borderBottom: "2px solid #ddd",
                        borderRadius: "0",
                        padding: "0.75rem 0",
                        fontSize: "1rem",
                        transition: "border-color 0.3s",
                      }}
                      onFocus={(e) =>
                        (e.target.style.borderBottomColor = "#7B6B98")
                      }
                      onBlur={(e) =>
                        (e.target.style.borderBottomColor = "#ddd")
                      }
                    />
                  </div>

                  <div
                    style={{
                      marginTop: "2rem",
                    }}
                    className="contact-form-btn-section mt-4"
                  >
                    <button
                      type="button"
                      onClick={() => console.log("Upload file clicked")}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        padding: "0.75rem 1.5rem",
                        background: "transparent",
                        border: "2px solid #FF6B35",
                        borderRadius: "25px",
                        color: "#FF6B35",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#FF6B35";
                        e.currentTarget.style.color = "#fff";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.color = "#FF6B35";
                      }}
                    >
                      <Upload size={20} />
                      Upload File
                    </button>

                    <button
                      type="button"
                      onClick={handleSubmit}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        padding: "0.75rem 2rem",
                        background: "#FF6B35",
                        border: "none",
                        borderRadius: "25px",
                        color: "#fff",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s",
                        boxShadow: "0 4px 15px rgba(255, 107, 53, 0.3)",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#FF5722";
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow =
                          "0 6px 20px rgba(255, 107, 53, 0.4)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "#FF6B35";
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(255, 107, 53, 0.3)";
                      }}
                    >
                      Send Message
                      <ArrowRight size={20} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row mt-5 pt-5">
              <div className="col-md-4">
                <h4
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "bold",
                    color: "#fff",
                    marginBottom: "2rem",
                  }}
                >
                  Quick links
                </h4>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  {[
                    { title: "Products", href: "/products" },
                    { title: "Blogs", href: "/blogs" },
                    { title: "Contact us", href: "/contact-us" },
                    { title: "FAQs", href: "/faqs" },
                  ].map((link) => (
                    <li key={link.title} style={{ marginBottom: "1rem" }}>
                      <a
                        href={link.href}
                        style={{
                          color: "#fff",
                          textDecoration: "none",
                          fontSize: "1.1rem",
                          transition: "all 0.3s",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.color = "#FFD700";
                          e.currentTarget.style.paddingLeft = "10px";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.color = "#fff";
                          e.currentTarget.style.paddingLeft = "0";
                        }}
                      >
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-md-4">
                <h4
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "bold",
                    color: "#fff",
                    marginBottom: "2rem",
                  }}
                >
                  Address
                </h4>
                <div
                  style={{
                    color: "#fff",
                    fontSize: "1.1rem",
                    lineHeight: "1.8",
                  }}
                >
                  <p style={{ marginBottom: "1rem" }}>
                    Sparling Compound, Shyam Nagar, Aligarh (U.P.), 202001,
                    India
                  </p>
                  <p style={{ marginBottom: "1rem" }}>Phone: +91-8077147169</p>
                  <p style={{ marginBottom: "1rem" }}>
                    Email: info@pupntreats.com
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                }}
                className="col-md-4 d-flex justify-content-end"
              >
                {[
                  {
                    name: "facebook",
                    icon: Facebook,
                    href: "https://www.facebook.com/people/Pupntreats/61581918573721/",
                  },
                  {
                    name: "instagram",
                    icon: Instagram,
                    href: "https://www.instagram.com/pupntreats?igsh=dW53cmlsNDNmd3Vs",
                  },
                  {
                    name: "LinkedIn",
                    icon: Linkedin,
                    href: "https://in.linkedin.com/company/pupntreats",
                  },
                ].map((social) => {
                  const Icon = social.icon;
                  return (
                    <a
                      key={social.name}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        width: "45px",
                        height: "45px",
                        borderRadius: "50%",
                        background: "#fff",
                        border: "2px solid #FF6B35",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#FF6B35",
                        textDecoration: "none",
                        transition: "all 0.3s",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#FF6B35";
                        e.currentTarget.style.color = "#fff";
                        e.currentTarget.style.transform = "translateY(-3px)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "#fff";
                        e.currentTarget.style.color = "#FF6B35";
                        e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <Icon size={22} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
